import { Component, OnInit } from '@angular/core';
import { Validators, AbstractControl, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbCalendar, NgbDatepickerConfig, NgbDate, NgbDatepickerI18n, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { swalError, swalInfo, swalSuccess } from '../../../shared/config/swalCommon';
import { numberIntMask, phoneMask, cellularMask, ciiuMask, numberCMask, numberPMask, nameMask } from '../../../shared/config/imaskCommon';
import { EMAIL_PATTERN } from '../../../shared/config/config';
import { setDate, setDateStructure } from '../../../shared/config/dateCommon';
import { resolvePetitionUserId } from '../../../shared/config/commons';
import {
  I18n, CustomDatepickerI18n, DateFormatService, ValueService,
  PaymentCapacityService, UserService, PersonaService, LogsService
} from '../../../services/services.index';
import { Value, Department, City, Reference, PaymentCapacity, User, AdjudgedInfo, People, Petition, LogsNav } from '../../../interfaces/interfaces.index';

@Component({
  selector: 'app-edit-cp',
  templateUrl: './edit-cp.component.html',
  styleUrls: ['./edit-cp.component.css'],
  styles: [`
  .card-footer { border-radius: 2rem 2rem 2rem 2rem !important; }
`],
providers: [
  I18n,
  { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  { provide: NgbDateParserFormatter, useClass: DateFormatService }
]
})
export class EditCpComponent implements OnInit {

  loadValues: boolean;
  values: Value[] = [];
  tr: Value[] = [];
  tp: Value[] = [];
  td: Value[] = [];
  s: Value[] = [];
  ec: Value[] = [];
  na: Value[] = [];
  tv: Value[] = [];
  ese: Value[] = [];
  act: Value[] = [];
  emp: Value[] = [];
  tc: Value[] = [];
  c: Value[] = [];
  sa: Value[] = [];
  a: Value[] = [];
  r: Value[] = [];
  tcs: Value[] = [];
  n: Value[] = [];
  p: Value[] = [];
  ar: Value[] = [];
  ca: Value[] = [];
  e: Value[] = [];
  pa: Value[] = [];
  ef: Value[] = [];
  df: Value[] = [];
  ci: Value[] = [];
  d: Department[] = [];
  c1: City[] = [];
  c10: City[] = [];
  l1: Value[] = [];
  c2: City[] = [];
  l2: Value[] = [];
  c3: City[] = [];
  l3: Value[] = [];
  c4: City[] = [];
  c40: City[] = [];
  c41: City[] = [];
  c42: City[] = [];
  c5: City[] = [];
  l5: Value[] = [];
  forma: FormGroup;
  mostrar: boolean;
  hoy: NgbDate;
  hoy18: NgbDate;
  email_pattern = EMAIL_PATTERN;
  numberIntMask = numberIntMask;
  currencyMask = numberCMask;
  phoneMask = phoneMask;
  cellularMask = cellularMask;
  ciiuMask = ciiuMask;
  percentMask = numberPMask;
  nameMask = nameMask;
  references: Reference[] = [];
  existeReferencia: boolean;
  paymentCapacity: PaymentCapacity;
  userLogged: User;
  n15 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  preLoad = false;
  adjudged: People;
  adjudgedInfo: AdjudgedInfo;
  actPetition: Petition;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private valueService: ValueService,
    public dpConfig: NgbDatepickerConfig,
    public calendar: NgbCalendar,
    private paymentCapacityService: PaymentCapacityService,
    private spinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private personaService: PersonaService,
    private logService: LogsService
  ) {
    this.userLogged = this.userService.user;
    this.hoy = calendar.getToday();
    this.hoy18 = new NgbDate(this.hoy.year - 18, this.hoy.month, this.hoy.day);
    dpConfig.maxDate = { year: 2099, month: 12, day: 31 };
    dpConfig.firstDayOfWeek = 7;

    this.actPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
    this.getUbicacion();
    this.getValues();

    this.forma = this.fb.group({
      id: [null as number | null],
      startDate: [this.hoy],
      transfer: ['No', Validators.required],
      role: [null as string | null, Validators.required],
      debtor: [null as string | null, Validators.required],
      contractNumber: [null as number | null, Validators.required],
      quotaNumber: [null as number | null, Validators.required],
      name: [null as string | null, Validators.required],
      lastName: [null as string | null, Validators.required],
      surname: [null as string | null],
      typeOfIdentity: ['CC', Validators.required],
      documentNumber: [null as string | null, Validators.required],
      expeditionDate: [null as NgbDateStruct | null, Validators.required],
      expeditionDepartment: [null as string | null, Validators.required],
      expeditionCity: [null as string | null, Validators.required],
      sex: ['M', Validators.required],
      dateOfBirth: [null as NgbDateStruct | null, Validators.required],
      nationality: ['1', Validators.required],
      civilStatus: [null as string | null, Validators.required],
      academicLevel: [null as number | null, Validators.required],
      profession: [null as string | null],
      otherProfession: [null as string | null],
      minorLoad: [null as string | null, Validators.required],
      higherLoad: [null as string | null, Validators.required],
      housing: [null as string | null, Validators.required],
      rent: ['No', Validators.required],
      address: [null as string | null, Validators.required],
      country: ['Colombia', Validators.required],
      department: [null as string | null, Validators.required],
      city: [null as string | null, Validators.required],
      cityOtherCountries: [null as string | null],
      location: [null as string | null],
      stratum: [null as string | null, Validators.required],
      yearsResidence: [null as string | null, Validators.required],
      phone: [null as string | null, {
        validators: [Validators.required, Validators.minLength(8)],
        updateOn: 'blur'
      }],
      cellular: [null as string | null, {
        validators: [Validators.required, Validators.minLength(8)],
        updateOn: 'blur'
      }],
      email: [null as string | null, {
        validators: [Validators.required, Validators.email, Validators.pattern(EMAIL_PATTERN)],
        updateOn: 'blur'
      }],
      emailAlt: [null as string | null, {
        validators: [, Validators.email, Validators.pattern(EMAIL_PATTERN)],
        updateOn: 'blur'
      }],
      name1: [null as string | null],
      lastName1: [null as string | null],
      surname1: [null as string | null],
      typeOfIdentity1: ['CC'],
      documentNumber1: [null as string | null],
      dateOfBirth1: [null as NgbDateStruct | null],
      sex1: ['M'],
      chevyPlan1: ['No'],
      address1: [null as string | null],
      country1: [null as string | null],
      department1: [null as string | null],
      city1: [null as string | null],
      location1: [null as string | null],
      phone1: [null as string | null],
      cellular1: [null as string | null],
      activities1: [null as string | null],
      ciiu: [null as string | null, Validators.required],
      job: [null as string | null, Validators.required],
      whichJob: [null as string | null],
      business: [null as string | null],
      antiquity: [null as string | null],
      position: [null as string | null],
      whichPosition: [null as string | null],
      chevyPlan: ['No', Validators.required],
      contract: [null as string | null],
      whichContract: [null as string | null, Validators.required],
      address2: [null as string | null, Validators.required],
      country2: [null as string | null],
      department2: [null as string | null, Validators.required],
      city2: [null as string | null, Validators.required],
      location2: [null as string | null],
      phone2: [null as string | null, Validators.required],
      cellular2: [null as string | null],
      activities2: [null as string | null],
      composition: [null as string | null],
      sectorActivity: [null as string | null],
      chamberOfCommerce: ['Si'],
      employees: [null as string | null],
      participation: [null as string | null],
      monthlyIncome: [null as string | null, Validators.required],
      otherIncome: [null as string | null],
      descriptionOtherIncome: [null as string | null],
      totalIncome: [null as string | null],
      totalExpenses: [null as number | null, Validators.required],
      totalAssets: [null as number | null, Validators.required],
      assetsDetail: [null as string | null],
      totalPassive: [null as string | null],
    });
    this.department.valueChanges.subscribe(() => this.city.reset());
    this.city.valueChanges.subscribe(() => this.location.reset());
    this.department1.valueChanges.subscribe(() => this.city1.reset());
    this.city1.valueChanges.subscribe(() => this.location1.reset());
    this.department2.valueChanges.subscribe(() => this.city2.reset());
    this.city2.valueChanges.subscribe(() => this.location2.reset());

    this.civilStatus.valueChanges.subscribe(x => {
      if (x === 'C' || x === 'U') {
        this.requiredField(this.name1);
        this.requiredField(this.lastName1);
        this.requiredField(this.surname1);
        this.requiredField(this.documentNumber1);
        this.requiredField(this.address1);
        this.requiredField(this.department1);
        this.requiredField(this.phone1);
        this.requiredField(this.activities1);
      } else {
        this.resetField(this.name1);
        this.resetField(this.lastName1);
        this.resetField(this.surname1);
        this.resetField(this.documentNumber1);
        this.resetField(this.address1);
        this.resetField(this.department1);
        this.resetField(this.phone1);
        this.resetField(this.activities1);
      }
    });

    this.academicLevel.valueChanges.subscribe(x => x > 3 && x < 7 ? this.requiredField(this.profession) : this.resetField(this.profession));

    this.job.valueChanges.subscribe(x => {
      if (x === '7') {
        this.requiredField(this.whichJob);
        this.requiredField(this.whichJob);
        this.resetField(this.business);
        this.resetField(this.contract);
        this.resetField(this.activities2);
        this.resetField(this.composition);
        this.resetField(this.sectorActivity);
        this.resetField(this.chamberOfCommerce);
        this.resetField(this.employees);
        this.resetField(this.participation);
        this.resetField(this.otherIncome);
      } else if (x === '5') {
        this.requiredField(this.otherIncome);
      }  else if (x === '2') {
        this.requiredField(this.activities2);
        this.requiredField(this.composition);
        this.requiredField(this.sectorActivity);
        this.requiredField(this.chamberOfCommerce);
        this.requiredField(this.employees);
        this.requiredField(this.otherIncome);
        this.resetField(this.business);
        this.resetField(this.whichJob);
        this.resetField(this.contract);
      } else if (x === '1' || x === '6') {
        this.requiredField(this.business);
        this.requiredField(this.position);
        this.requiredField(this.contract);
        this.resetField(this.whichJob);
        this.resetField(this.activities2);
        this.resetField(this.composition);
        this.resetField(this.sectorActivity);
        this.resetField(this.chamberOfCommerce);
        this.resetField(this.employees);
        this.resetField(this.participation);
        this.resetField(this.otherIncome);
      } else {
        this.resetField(this.business);
        this.resetField(this.whichJob);
        this.resetField(this.contract);
        this.resetField(this.activities2);
        this.resetField(this.composition);
        this.resetField(this.sectorActivity);
        this.resetField(this.chamberOfCommerce);
        this.resetField(this.employees);
        this.resetField(this.participation);
        this.resetField(this.otherIncome);
      }

    });

    this.business.valueChanges.subscribe(x => {
      if (x !== null && x !== '') {
        this.requiredField(this.antiquity);
        this.requiredField(this.position);
      } else {
        this.resetField(this.antiquity);
        this.resetField(this.position);
      }
    });

    this.position.valueChanges.subscribe(x => {
      if (x === '32') {
        this.requiredField(this.whichPosition);
      } else {
        this.resetField(this.whichPosition);
      }
    });

    this.contract.valueChanges.subscribe(x => x === '4' ? this.requiredField(this.whichContract) : this.resetField(this.whichContract));

    this.otherIncome.valueChanges.subscribe(x => x !== null && x !== '' ? this.requiredField(this.descriptionOtherIncome) : this.resetField(this.descriptionOtherIncome));

    this.totalAssets.valueChanges.subscribe(x => x !== null && x !== '' ? this.requiredField(this.assetsDetail) : this.resetField(this.assetsDetail));
   }

  ngOnInit(): void {
    this.addLogsNav();

    setTimeout(() => this.data(), 500);
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  data = () => {
    this.adjudgedInfo = this.actPetition.adjudgedInfo;
    this.transfer.setValue('No');
    this.role.setValue('D');
    this.debtor.setValue('D1');
    this.contractNumber.setValue(this.adjudgedInfo.contractNumber);
    this.quotaNumber.setValue(this.adjudgedInfo.quotaNumber);
    // Antes siempre cargaba al titular: un codeudor que editaba veía (y reenviaba) los datos del titular.
    this.personaService.getPeopleByUser(resolvePetitionUserId(this.actPetition, this.userLogged?.id)).subscribe(data => {
      this.adjudged = data;
      this.name.setValue(data.name);
      this.lastName.setValue(data.lastName);
      this.surname.setValue(data.surname);
      this.typeOfIdentity.setValue(data.typeOfIdentity);
      this.documentNumber.setValue(data.documentNumber);
      this.dateOfBirth.setValue(setDateStructure(data.dateOfBirth));
      this.address.setValue(data.address);
      this.department.setValue(data.ubication.departmentId);
      this.c1 = this.d.find(x => x.valueId === data.ubication.departmentId)?.cities;
      this.city.setValue(data.ubication.cityId);
      this.l1 = this.c1?.find(x => x.valueId === data.ubication.cityId)?.localities;
      this.location.setValue(data.ubication.localityId);
      this.phone.setValue(data.phone);
      this.cellular.setValue(data.cellPhone);
      this.email.setValue(data.email);
    }, error => this.handleError(error.error));
  }

  loadData = (data: PaymentCapacity) => {
    this.hoy =  this.hoy;
    this.startDate.setValue(setDateStructure(data.date));
    this.transfer.setValue(data.transfer ? 'Si' : 'No');
    this.role.setValue(data.role.valueId);
    this.debtor.setValue(data.debtor.valueId);
    this.contractNumber.setValue(data.contractNumber);
    this.quotaNumber.setValue(data.quotaNumber);

    this.name.setValue(data.applicant.name);
    this.lastName.setValue(data.applicant.lastName);
    this.surname.setValue(data.applicant.surname);
    this.typeOfIdentity.setValue(data.applicant.typeOfIdentity);
    this.documentNumber.setValue(data.applicant.documentNumber);
    this.expeditionDate.setValue(setDateStructure(data.applicant.expDate));
    this.valueService.getUbication(data.applicant.expCity).then(ubic => {
      this.c10 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.expeditionDepartment.setValue(ubic.departmentId);
      this.expeditionCity.setValue(ubic.cityId);
    }).catch(error => this.handleError(error.error));
    this.sex.setValue(data.applicant.sex.valueId);
    this.dateOfBirth.setValue(setDateStructure(data.applicant.dateOfBirth));
    this.nationality.setValue(data.applicant.nacionality.valueId);
    this.civilStatus.setValue(data.applicant.civilStatus.valueId);
    this.academicLevel.setValue(data.applicant.academicLevel.valueId);
    this.profession.setValue(data.applicant.profession.valueId);
    this.minorLoad.setValue(data.applicant.dependentsOver18);
    this.higherLoad.setValue(data.applicant.dependentsUnder18);
    this.housing.setValue(data.applicant.housingType.valueId);
    this.rent.setValue(data.applicant.declareRent ? 'Si' : 'No');
    this.address.setValue(data.applicant.address);
    this.valueService.getUbication(data.applicant.city).then(ubic => {
      this.c1 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.l1 = this.c1.find(x => x.valueId === ubic.cityId).localities;
      this.department.setValue(ubic.departmentId);
      this.city.setValue(ubic.cityId);
      this.location.setValue(ubic.localityId);
    }).catch(error => this.handleError(error.error));
    this.stratum.setValue(data.applicant.stratumSE.valueId);
    this.yearsResidence.setValue(data.applicant.yearsInResidence.toString());
    this.phone.setValue(data.applicant.phone);
    this.cellular.setValue(data.applicant.cellPhone);
    this.email.setValue(data.applicant.email);

    this.name1.setValue(data.spouse.name);
    this.lastName1.setValue(data.spouse.lastName);
    this.surname1.setValue(data.spouse.surname);
    this.typeOfIdentity1.setValue(data.spouse.typeOfIdentity);
    this.documentNumber1.setValue(data.spouse.documentNumber);
    this.dateOfBirth1.setValue(setDateStructure(data.spouse.dateOfBirth));
    this.address1.setValue(data.spouse.address);
    this.valueService.getUbication(data.spouse.city).then(ubic => {
      this.c2 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.l2 = this.c2.find(x => x.valueId === ubic.cityId).localities;
      this.department1.setValue(ubic.departmentId);
      this.city1.setValue(ubic.cityId);
      this.location1.setValue(ubic.localityId);
    }).catch(error => this.handleError(error.error));
    this.phone1.setValue(data.spouse.phone);
    this.activities1.setValue(data.spouse.economicActivity.valueId);

    this.ciiu.setValue(data.ecoActivApplicant.ciiuCode.valueId);
    this.job.setValue(data.ecoActivApplicant.job.valueId);
    this.whichJob.setValue(data.ecoActivApplicant.whichJob);
    this.business.setValue(data.ecoActivApplicant.companyName);
    this.antiquity.setValue(data.ecoActivApplicant.antiquity.valueId);
    this.position.setValue(data.ecoActivApplicant.position.valueId);
    this.chevyPlan.setValue(data.ecoActivApplicant.relationship ? 'Si' : 'No');
    this.contract.setValue(data.ecoActivApplicant.contract.valueId);
    this.whichContract.setValue(data.ecoActivApplicant.whichContract);
    this.address2.setValue(data.ecoActivApplicant.address);
    this.valueService.getUbication(data.ecoActivApplicant.city).then(ubic => {
      this.c3 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.l3 = this.c3.find(x => x.valueId === ubic.cityId).localities;
      this.department2.setValue(ubic.departmentId);
      this.city2.setValue(ubic.cityId);
      this.location2.setValue(ubic.localityId);
    }).catch(error => this.handleError(error.error));
    this.phone2.setValue(data.ecoActivApplicant.phones);
    this.activities2.setValue(data.ecoActivApplicant.ecoActivIndependent);
    this.composition.setValue(data.ecoActivApplicant.composition?.valueId);
    this.sectorActivity.setValue(data.ecoActivApplicant.sector?.valueId);
    this.chamberOfCommerce.setValue(data.ecoActivApplicant.chamberOfCommerce ? 'Si' : 'No');
    this.employees.setValue(data.ecoActivApplicant.numEmployees.toString());
    this.participation.setValue(data.ecoActivApplicant?.numPartCompany ? data.ecoActivApplicant.numPartCompany.toString() : null);

    this.monthlyIncome.setValue(data.financialInfo.monthlyIncome ? data.financialInfo.monthlyIncome.toString() : null);
    this.otherIncome.setValue(data.financialInfo.otherMonthlyIncome ? data.financialInfo.otherMonthlyIncome.toString() : null);
    this.descriptionOtherIncome.setValue(data.financialInfo.descripOtherMI);
    this.sumTotalIncome();
    this.totalExpenses.setValue(data.financialInfo.totalExpenses ? data.financialInfo.totalExpenses.toString() : null);
    this.totalAssets.setValue(data.financialInfo.totalAssets ? data.financialInfo.totalAssets.toString() : null);
    this.assetsDetail.setValue(data.financialInfo.assetsDetail ? JSON.parse(data.financialInfo.assetsDetail) : null);
    this.totalPassive.setValue(data.financialInfo.totalPassive ? data.financialInfo.totalPassive.toString() : null);


  }

  getUbicacion = () => this.valueService.getAllUbications().subscribe(data => this.d = data, error => this.handleError(error.error));

  getValues = () => {
    this.loadValues = true;
    const types = ['rol', 'deudor', 'tipoident', 'sexo', 'estadocivil', 'nivelacademico', 'tipovivienda', 'estratose', 'actividades', 'empleo', 'tipocontrato', 'composicion', 'sectorae', 'activos', 'tiporelacion', 'tipocuenta', 'banco', 'nacionalidad', 'relacion', 'profesion', 'residencia', 'cargo', 'empleados', 'debitar'];

    this.valueService.getValuesGroup(types).subscribe(data => {
      const buscar = (type: string) => this.values.filter(x => x.type === type);
      const ordenar = (values: Value[], orderName = true) => values.sort((a, b) => orderName ? a.name.localeCompare(b.name) : parseInt(a.valueId, 0) - parseInt(b.valueId, 0));
      this.values = data;
      this.tr = ordenar(buscar('rol'));
      this.tp = ordenar(buscar('deudor'));
      this.td = ordenar(buscar('tipoident'));
      this.s = ordenar(buscar('sexo'));
      this.ec = ordenar(buscar('estadocivil'));
      this.na = ordenar(buscar('nivelacademico'), false);
      this.tv = ordenar(buscar('tipovivienda'));
      this.ese = ordenar(buscar('estratose'));
      this.act = ordenar(buscar('actividades'));
      this.emp = ordenar(buscar('empleo'));
      this.tc = ordenar(buscar('tipocontrato'));
      this.c = ordenar(buscar('composicion'));
      this.sa = ordenar(buscar('sectorae'));
      this.a = ordenar(buscar('activos'));
      this.r = ordenar(buscar('tiporelacion'));
      this.tcs = ordenar(buscar('tipocuenta'));
      this.n = ordenar(buscar('nacionalidad'));
      this.p = ordenar(buscar('profesion'), false);
      this.ar = ordenar(buscar('residencia'), false);
      this.ca = ordenar(buscar('cargo'), false);
      this.e = ordenar(buscar('empleados'), false);
      this.pa = ordenar(buscar('relacion'), false);
      this.ef = ordenar(buscar('banco'));
      this.df = ordenar(buscar('debitar'), false);
      this.ci = ordenar(buscar('actividades'), false);
    }, error => this.handleError(error.error));
    this.loadValues = false;
  }

  clearField = (field: AbstractControl) => {
    field.clearValidators();
    field.updateValueAndValidity();
  }

  requiredField = (field: AbstractControl, email = false) => {
    field.setValidators(email ? [Validators.required, Validators.pattern(EMAIL_PATTERN)] : Validators.required);
    field.updateValueAndValidity();
  }

  resetField = (field: AbstractControl) => {
    this.clearField(field);
    field.reset();
  }

  validateField = (field: AbstractControl) => {
    field.markAsTouched();
    field.updateValueAndValidity();
  }

  sumTotalIncome = () => this.totalIncome.setValue((parseInt(this.monthlyIncome.value ? this.monthlyIncome.value : 0, 0) + parseInt(this.otherIncome.value ? this.otherIncome.value : 0, 0)).toString());

  validarForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validarForm(control);
      }
    });
  }

  editar = () => {
    if (this.forma.invalid) {
      Swal.fire(swalInfo('Faltan campos requeridos, verifique'));
      this.validarForm(this.forma);
      return;
    }

    this.spinnerService.show();
    sessionStorage.setItem("capacidadPagoEdit", JSON.stringify(this.datosForm()))
    this.paymentCapacityService.putPaymentCapacity(this.datosForm()).subscribe(data => {
      this.spinnerService.hide();
      Swal.fire(swalSuccess()).then(() => this.router.navigate([`proceso`]));
    }, error => this.handleError(error.error));
  }

  datosForm = (): PaymentCapacity => {
    if (this.paymentCapacity) {
    } else {
      this.paymentCapacity = {
        // Id de la capacidad de pago que se edita (/capacidad-pago-edit/:id). Sin él, el backend no
        // sabía cuál editar y un asesor que editaba al codeudor sobrescribía la del titular.
        id: Number(this.activatedRoute.snapshot.paramMap.get('id')) || 0,
        petitionId: this.actPetition.id,
        date: setDate(this.startDate.value),
        transfer: this.transfer.value === 'Si' ? true : false,
        roleId: this.role.value,
        debtorId: this.debtor.value,
        contractNumber: this.contractNumber.value,
        quotaNumber: this.quotaNumber.value,
        applicant: {
          id: this.adjudged.id,
          name: this.name.value,
          lastName: this.lastName.value,
          surname: this.surname.value,
          typeOfIdentity: this.typeOfIdentity.value,
          documentNumber: (this.documentNumber.value).toString(),
          expDate: setDate(this.expeditionDate.value),
          expCity: this.expeditionCity.value,
          sexId: this.sex.value,
          dateOfBirth: setDate(this.dateOfBirth.value),
          nacionalityId: this.nationality.value,
          civilStatusId: this.civilStatus.value,
          academicLevelId: this.academicLevel.value,
          professionId: this.profession.value,
          otherProfession: this.otherProfession.value,
          dependentsOver18: Number(this.minorLoad.value),
          dependentsUnder18: Number(this.higherLoad.value),
          housingTypeId: this.housing.value,
          declareRent: this.rent.value === 'Si' ? true : false,
          address: this.address.value,
          userId: this.userLogged.id,
          city: this.location.value ? this.location.value : this.city.value,
          stratumSEId: this.stratum.value,
          yearsInResidence: parseInt(this.yearsResidence.value, 0),
          phone: this.phone.value.toString(),
          cellPhone: this.cellular.value.toString(),
          email: this.email.value,
          emailAlt: this.emailAlt.value,
          cityOtherCountries: this.cityOtherCountries.value,
          country: this.country.value
        },
        spouse: this.civilStatus.value === 'C' || this.civilStatus.value === 'U' ? {
          name: this.name1.value,
          lastName: this.lastName1.value,
          surname: this.surname1.value,
          typeOfIdentity: this.typeOfIdentity1.value,
          documentNumber: this.documentNumber1.value.toString(),
          dateOfBirth: setDate(this.dateOfBirth1.value),
          sexId: this.sex1.value,
          relationship: this.chevyPlan1.value === 'Si' ? true : false,
          address: this.address1.value,
          city: this.location1.value ? this.location1.value : this.city1.value,
          phone: this.phone1.value.toString(),
          cellPhone: this.cellular1.value.toString(),
          spounseEconomicActivity: this.activities1.value
        } : null,
        ecoActivApplicant: {
          ciiuCodeId: this.ciiu.value,
          jobId: this.job.value,
          whichJob: this.whichJob.value,
          companyName: this.business.value,
          antiquityId: this.antiquity.value ? this.antiquity.value : null,
          positionId: this.position.value,
          relationship: this.chevyPlan.value === 'Si' ? true : false,
          contractId: this.contract.value,
          whichContract: this.whichJob.value,
          address: this.address1.value,
          city: this.location1.value ? this.location1.value : this.city.value,
          phones: this.phone1.value?.toString(),
          cellPhones: this.cellular2.value?.toString(),
          ecoActivIndependent: this.activities2.value,
          compositionId: this.composition.value,
          sectorId: this.sectorActivity.value,
          chamberOfCommerce: this.chamberOfCommerce.value === 'Si' ? true : false,
          numEmployees: parseInt(this.employees.value, 0),
          numPartCompany: this.participation.value ? parseFloat(this.participation.value) : 0
        },
        financialInfo: {
          monthlyIncome: parseInt(this.monthlyIncome.value, 0),
          otherMonthlyIncome: parseInt(this.otherIncome.value, 0),
          descripOtherMI: this.descriptionOtherIncome.value,
          totalIncome: parseInt(this.totalIncome.value, 0),
          totalExpenses: parseInt(this.totalExpenses.value, 0),
          totalAssets: parseInt(this.totalAssets.value, 0),
          assetsDetail: this.assetsDetail.value ? JSON.stringify(this.assetsDetail.value) : null,
          totalPassive: parseInt(this.totalPassive.value, 0)
        }
      };
      if (this.job.value !== '2' && this.job.value !== '3') this.paymentCapacity.references.splice(2, 1);
    }
    return this.paymentCapacity;
  }

  handleError = (err) => { this.spinnerService.hide(); Swal.fire(swalError('Ha ocurrido un error', err.error?err.error.userMessage:err.userMessage)); };

  get id() { return this.forma.get('id'); }
  get startDate() { return this.forma.get('startDate'); }
  get transfer() { return this.forma.get('transfer'); }
  get role() { return this.forma.get('role'); }
  get debtor() { return this.forma.get('debtor'); }
  get contractNumber() { return this.forma.get('contractNumber'); }
  get quotaNumber() { return this.forma.get('quotaNumber'); }
  get name() { return this.forma.get('name'); }
  get lastName() { return this.forma.get('lastName'); }
  get surname() { return this.forma.get('surname'); }
  get typeOfIdentity() { return this.forma.get('typeOfIdentity'); }
  get documentNumber() { return this.forma.get('documentNumber'); }
  get expeditionDate() { return this.forma.get('expeditionDate'); }
  get expeditionDepartment() { return this.forma.get('expeditionDepartment'); }
  get expeditionCity() { return this.forma.get('expeditionCity'); }
  get sex() { return this.forma.get('sex'); }
  get dateOfBirth() { return this.forma.get('dateOfBirth'); }
  get nationality() { return this.forma.get('nationality'); }
  get civilStatus() { return this.forma.get('civilStatus'); }
  get academicLevel() { return this.forma.get('academicLevel'); }
  get profession() { return this.forma.get('profession'); }
  get otherProfession() { return this.forma.get('otherProfession'); }
  get minorLoad() { return this.forma.get('minorLoad'); }
  get higherLoad() { return this.forma.get('higherLoad'); }
  get housing() { return this.forma.get('housing'); }
  get rent() { return this.forma.get('rent'); }
  get address() { return this.forma.get('address'); }
  get country() { return this.forma.get('country'); }
  get department() { return this.forma.get('department'); }
  get city() { return this.forma.get('city'); }
  get cityOtherCountries() { return this.forma.get('city'); }
  get location() { return this.forma.get('location'); }
  get stratum() { return this.forma.get('stratum'); }
  get yearsResidence() { return this.forma.get('yearsResidence'); }
  get phone() { return this.forma.get('phone'); }
  get cellular() { return this.forma.get('cellular'); }
  get email() { return this.forma.get('email'); }
  get name1() { return this.forma.get('name1'); }
  get lastName1() { return this.forma.get('lastName1'); }
  get surname1() { return this.forma.get('surname1'); }
  get typeOfIdentity1() { return this.forma.get('typeOfIdentity1'); }
  get documentNumber1() { return this.forma.get('documentNumber1'); }
  get dateOfBirth1() { return this.forma.get('dateOfBirth1'); }
  get sex1() { return this.forma.get('sex1'); }
  get chevyPlan1() { return this.forma.get('chevyPlan1'); }
  get address1() { return this.forma.get('address1'); }
  get country1() { return this.forma.get('country1'); }
  get department1() { return this.forma.get('department1'); }
  get city1() { return this.forma.get('city1'); }
  get location1() { return this.forma.get('location1'); }
  get phone1() { return this.forma.get('phone1'); }
  get cellular1() { return this.forma.get('cellular1'); }
  get activities1() { return this.forma.get('activities1'); }
  get ciiu() { return this.forma.get('ciiu'); }
  get job() { return this.forma.get('job'); }
  get whichJob() { return this.forma.get('whichJob'); }
  get business() { return this.forma.get('business'); }
  get antiquity() { return this.forma.get('antiquity'); }
  get position() { return this.forma.get('position'); }
  get whichPosition() { return this.forma.get('whichPosition'); }
  get chevyPlan() { return this.forma.get('chevyPlan'); }
  get contract() { return this.forma.get('contract'); }
  get whichContract() { return this.forma.get('whichContract'); }
  get address2() { return this.forma.get('address2'); }
  get country2() { return this.forma.get('country2'); }
  get department2() { return this.forma.get('department2'); }
  get city2() { return this.forma.get('city2'); }
  get location2() { return this.forma.get('location2'); }
  get phone2() { return this.forma.get('phone2'); }
  get cellular2() { return this.forma.get('cellular2'); }
  get activities2() { return this.forma.get('activities2'); }
  get composition() { return this.forma.get('composition'); }
  get sectorActivity() { return this.forma.get('sectorActivity'); }
  get chamberOfCommerce() { return this.forma.get('chamberOfCommerce'); }
  get employees() { return this.forma.get('employees'); }
  get participation() { return this.forma.get('participation'); }
  get monthlyIncome() { return this.forma.get('monthlyIncome'); }
  get otherIncome() { return this.forma.get('otherIncome'); }
  get descriptionOtherIncome() { return this.forma.get('descriptionOtherIncome'); }
  get totalIncome() { return this.forma.get('totalIncome'); }
  get totalExpenses() { return this.forma.get('totalExpenses'); }
  get totalAssets() { return this.forma.get('totalAssets'); }
  get assetsDetail() { return this.forma.get('assetsDetail'); }
  get totalPassive() { return this.forma.get('totalPassive'); }
  get emailAlt() { return this.forma.get('emailAlt'); }
}
